var r="@hpstellar/core/countdown-timer";export{r as countdownTimerTestId};
